import { getCountryStateNames } from '../utils';

// TODO: To be refactored as part of AutocompleteAddress component implementation
export const getInitialProjectAddress = ({
  addressLine1,
  city,
  stateOrProvince,
  postalCode,
  country,
}) => {
  let result = '';
  const addressLine1Empty = addressLine1 === '' || addressLine1 === null;
  const cityEmpty = city === '' || city === null;
  const stateOrProvinceEmpty =
    stateOrProvince === '' || stateOrProvince === null;
  const postalCodeEmpty = postalCode === '' || postalCode === null;
  const addressLineAndCityEmpty = addressLine1Empty && cityEmpty;
  const previousEmpty =
    addressLineAndCityEmpty && stateOrProvinceEmpty && postalCodeEmpty;
  const countryEmpty = country === '' || country === null;
  const { countryName, stateName } = getCountryStateNames(
    country,
    stateOrProvince
  );

  if (!addressLine1Empty) {
    result += addressLine1;
  }

  if (!cityEmpty) {
    result += (!addressLine1Empty ? ', ' : '') + city;
  }

  if (!stateOrProvinceEmpty) {
    result += (!addressLineAndCityEmpty ? ', ' : '') + stateName;
  }

  if (!postalCodeEmpty && stateOrProvinceEmpty) {
    result += (!addressLineAndCityEmpty ? ', ' : '') + postalCode;
  }

  if (!postalCodeEmpty && !stateOrProvinceEmpty) {
    result += ` ${postalCode}`;
  }

  if (!countryEmpty) {
    result += (!previousEmpty ? ', ' : '') + countryName;
  }
  return result;
};

export const pickAddressProps = (data) => {
  const addressProps = [
    'addressLine1',
    'addressLine2',
    'city',
    'stateOrProvince',
    'postalCode',
    'country',
  ];

  return Object.keys(data)
    .filter((key) => addressProps.includes(key))
    .reduce(
      (obj, key) => ({
        ...obj,
        [key]: data[key],
      }),
      {}
    );
};

export const translateDataToState = (data) => {
  const validProps = [
    'name',
    'type',
    'addressLine1',
    'addressLine2',
    'city',
    'stateOrProvince',
    'postalCode',
    'country',
    'timezone',
    'jobNumber',
    'startDate',
    'endDate',
    'projectValue',
  ];
  const filtered = Object.keys(data)
    .filter((key) => validProps.includes(key))
    .reduce(
      (obj, key) => ({
        ...obj,
        [key]: data[key],
      }),
      {}
    );

  return {
    ui: {
      autocompletedAddress: getInitialProjectAddress(filtered),
      // NOTE: proyectType Fix (must be fixed on the backend)
      localizedType: filtered.type,
    },
    data: { ...filtered },
    originalData: { ...filtered },
  };
};
